import styled from 'styled-components';

export const FooterContainer = styled.footer`
  background-color: var(--bg-white);
  padding: 60px 20px 20px;
  border-top: 3px solid transparent;
  border-image: linear-gradient(90deg, var(--primary-color) 0%, var(--secondary-color) 100%) 1;
  display: flex;
  flex-direction: column;
  align-items: center;

  @media (max-width: 768px) {
    padding: 32px 16px 12px;
  }
`;

export const TopSection = styled.div`
  width: 100%;
  max-width: 1140px;
  display: grid;
  grid-template-columns: minmax(200px, 0.9fr) minmax(0, 2.1fr);
  align-items: start;
  column-gap: 48px;
  row-gap: 32px;
  margin-bottom: 40px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    justify-items: center;
    gap: 24px;
    margin-bottom: 24px;
  }
`;

export const LogoAndSocials = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  text-align: left;

  p {
    font-size: 14px;
    color: #718096;
    max-width: 260px;
    line-height: 1.5;
    margin: 0;
    text-align: left;
  }

  @media (max-width: 768px) {
    align-items: center;
    text-align: center;
    width: 100%;

    p {
      text-align: center;
    }
  }
`;

export const Logo = styled.img`
  width: 130px;
  margin: 0 0 8px 0;
  display: block;

  @media (max-width: 768px) {
    width: 100px;
    margin-left: auto;
    margin-right: auto;
  }

  @media (max-width: 480px) {
    width: 84px;
    margin-bottom: 6px;
  }
`;

export const SocialIcons = styled.div`
  display: flex;
  gap: 20px;
  font-size: 20px;

  a {
    color: var(--text-primary);
    transition: var(--transition-fast);

    &:hover {
      color: var(--secondary-color);
      transform: translateY(-2px);
    }
  }
`;

export const LinkSections = styled.div`
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 24px 32px;
  width: 100%;
  justify-items: start;

  @media (max-width: 768px) {
    max-width: 420px;
    margin: 0 auto;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    justify-items: center;
    text-align: center;
    gap: 28px 16px;
  }
`;

export const LinkGroup = styled.div`
  min-width: 0;
  width: 100%;

  @media (max-width: 768px) {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
  }
`;

export const LinkTitle = styled.h4`
  font-size: 15px;
  font-weight: 700;
  color: #1a202c;
  margin-top: 0;
  margin-bottom: 20px;

  @media (max-width: 768px) {
    text-align: center;
    margin-bottom: 12px;
  }
`;

export const FooterLink = styled.a`
  display: block;
  font-size: 15px;
  color: #718096;
  margin-bottom: 14px;
  text-decoration: none;
  transition: var(--transition-fast);

  &:hover {
    color: var(--primary-color);
  }

  @media (max-width: 768px) {
    text-align: center;
    margin-bottom: 10px;
  }
`;

export const BottomBar = styled.div`
  width: 100%;
  max-width: 1140px;
  border-top: 1px solid #eaeaea;
  padding: 30px 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 14px;
  color: #718096;

  @media (max-width: 768px) {
    flex-direction: column-reverse;
    justify-content: center;
    align-items: center;
    gap: 12px;
    padding: 20px 0 8px;
    text-align: center;
  }
`;

export const SocialTextLinks = styled.div`
  display: flex;
  gap: 24px;
  
  a {
    color: #718096;
    text-decoration: none;
    transition: var(--transition-fast);
    
    &:hover {
      color: var(--primary-color);
    }
  }

  @media (max-width: 768px) {
    justify-content: center;
  }
`;
